// Původní název:		invia.initPrint
// Původní umístění:	shared/js/main-desktop.js
// Status:				Používané
// Funkcionalita:		Pošle GA event, když návštěvník vytiskne stránku
// Použito:				Globání
// #CHECKED jthiemel 190109


import { captureException } from '@invia/web-library/helpers/console';
import { getPageType } from '@invia/web-library/helpers/getPageType';
import { GTMsendEvent } from '@invia/web-library/helpers/gtm';

export const init = ($target) => {
	var hasPageBeenPrinted = false;

	var beforePrint = function () {
		try {
			// Chrome ten event spousti 2x, tak aby se to trackovalo pouze 1x
			if (!hasPageBeenPrinted) {
                GTMsendEvent('Print', getPageType(), 'ok', 0);
			}

			hasPageBeenPrinted = true;
		} catch (err) {
			captureException(err);
		}
	};

	try {
		// @see http://tjvantoll.com/2012/06/15/detecting-print-requests-with-javascript/

		if (window.matchMedia) {
			// reseni pro Chrome and IE, kde nefunguje udalost onbeforeprint
			window.matchMedia('print').addListener(function (mql) {
				if (mql.matches) {
					beforePrint();
				}
			});
		}

		window.onbeforeprint = beforePrint;
	} catch (err) {
		captureException(err);
	}
};
